// extracted by mini-css-extract-plugin
export default {"base":"base-XDq1J","dial1":"dial1-kVD0e","dial2":"dial2-vCUJ0","dial3":"dial3-EVG92","dialFade":"dialFade-p7Dpv"};